export function price2StringPrice(price_i) {
  let price = price_i;

  if (price !== null && price.length === 1 && price[0] === "-") {
    return price;
  }

  if (typeof price !== "number") {
    if (price !== "") {
      try {
        price = parseInt(price_i);
      } catch (error) {
        throw new Error(error);
      }
    }
  }
  return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export function parseFormattedPrice(formattedPrice) {
  const numericPrice = parseFloat(formattedPrice.replace(/ /g, ""));

  if (formattedPrice.length === 1 && formattedPrice[0] === "-") {
    return formattedPrice;
  }
  // Check if the conversion was successful
  if (!isNaN(numericPrice)) {
    return numericPrice;
  } else {
    return "";
  }
}

export function formatPrice(price) {
  return new Intl.NumberFormat("sv-SE", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price);
}
